// Import model
import { UploadFileOptions } from '../models/UploadFileOptions';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UploadFileOptions - handles JSON serialization and deserialization with type validation
 */
export class UploadFileOptionsSerializer {
  /**
   * Deserializes a JSON string into a UploadFileOptions instance
   */
  static deserialize(json: string): UploadFileOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UploadFileOptions instance
   */
  static fromObject(obj: any): UploadFileOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UploadFileOptions');
    }


    const instance: UploadFileOptions = {
      name: obj['Name'] as string,
      owner: obj['Owner'] as string | undefined,
      remoteFileFlowId: obj['RemoteFileFlowId'] as string | undefined,
      remoteFileFlowIdName: obj['RemoteFileFlowId|Name'] as string | undefined,
      remoteFileObjectStatusId: obj['RemoteFileObjectStatusId'] as string | undefined,
      remoteFileObjectStatusIdName: obj['RemoteFileObjectStatusId|Name'] as string | undefined,
      remotePath: obj['RemotePath'] as string,
      remoteFolderId: obj['RemoteFolderId'] as string | undefined,
      remoteFolderIdName: obj['RemoteFolderId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UploadFileOptions instances
   */
  static deserializeArray(json: string): UploadFileOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UploadFileOptions instance to a JSON string
   */
  static serialize(instance: UploadFileOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UploadFileOptions instance to a plain object
   */
  static toObject(instance: UploadFileOptions): any {
    return {
      'Name': instance.name,
      'Owner': instance.owner,
      'RemoteFileFlowId': instance.remoteFileFlowId,
      'RemoteFileFlowId|Name': instance.remoteFileFlowIdName,
      'RemoteFileObjectStatusId': instance.remoteFileObjectStatusId,
      'RemoteFileObjectStatusId|Name': instance.remoteFileObjectStatusIdName,
      'RemotePath': instance.remotePath,
      'RemoteFolderId': instance.remoteFolderId,
      'RemoteFolderId|Name': instance.remoteFolderIdName,
    };
  }

  /**
   * Serializes an array of UploadFileOptions instances to a JSON string
   */
  static serializeArray(instances: UploadFileOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
